import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

type WarningDialogProps = {
    open: boolean
    onClose: () => void
    title: React.ReactNode
    text: React.ReactNode
    buttonText: React.ReactNode
    dialogTitleId?: string
}

const WarningDialog = ({ open, onClose, title, text, buttonText, dialogTitleId }: WarningDialogProps) => {
    const titleId = dialogTitleId ?? 'warning-dialog-title'

    return (
        <Dialog open={open} onClose={onClose} aria-labelledby={titleId}>
            <DialogTitle id={titleId}>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{text}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} autoFocus color="error">
                    {buttonText}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default WarningDialog
